"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _usePrevious = require("./hooks/usePrevious");
var _TabTrap = _interopRequireDefault(require("./styles/TabTrap"));
var _excluded = ["isActive", "firstId", "lastId", "element", "onDeactivate", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TabTrap = /*#__PURE__*/_react["default"].forwardRef(function TabTrap(_ref, _ref2) {
  var isActive = _ref.isActive,
    firstId = _ref.firstId,
    lastId = _ref.lastId,
    element = _ref.element,
    onDeactivate = _ref.onDeactivate,
    children = _ref.children,
    passProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var Container = element;
  var prevActive = (0, _usePrevious.usePrevious)(isActive);
  var internalRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var nowActive = !prevActive && isActive;
    var wasActive = !isActive && prevActive;
    if (nowActive) {
      requestAnimationFrame(function () {
        var target = internalRef.current.querySelector("#".concat(firstId));
        if (target) {
          target.focus();
        }
      });
    } else if (wasActive && onDeactivate) {
      onDeactivate();
    }
  }, [internalRef, isActive, prevActive, firstId, onDeactivate]);
  function focusCycler(e) {
    e.persist();
    var prev = e.relatedTarget;
    var isPrevATrap = prev && prev.className.includes('tab-trap');
    var isCurrTopTrap = e.target.className.includes('tab-trap--top');
    if (isPrevATrap) {
      var targetId = isCurrTopTrap ? firstId : lastId;
      var targetElement = internalRef.current.querySelector("#".concat(targetId));
      targetElement.focus();
      return;
    }
    var nextTrapClass = isCurrTopTrap ? '.tab-trap--bottom' : '.tab-trap--top';
    var nextTrap = internalRef.current.querySelector(nextTrapClass);
    if (nextTrap === document.activeElement) {
      var _targetElement = internalRef.current.querySelector("#".concat(firstId));
      _targetElement.focus();
      return;
    }
    nextTrap.focus();
  }
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    ref: function ref(elementRef) {
      internalRef.current = elementRef;
      _ref2.hasOwnProperty('current') ? _ref2.current = elementRef : _ref2(elementRef);
    }
  }, passProps), isActive && /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames["default"])('tab-trap tab-trap--top', _TabTrap["default"].tabTrap),
    onFocus: focusCycler
  }), children, isActive && /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames["default"])('tab-trap tab-trap--bottom', _TabTrap["default"].tabTrap),
    onFocus: focusCycler
  }));
});
TabTrap.defaultProps = {
  element: 'div'
};
var _default = exports["default"] = TabTrap;